<wlm-popup-wrapper
  [titleKey]="titleKey"
  [showCloseButton]="false"
  [showCancelButton]="true"
  [popupContainerClass]="'inherit-height'"
  (popupClose)="cancel($event)"
>
  <ng-container popup-content>
    <ct-create-dashboard-widget-form
      (cartSelectionSubmit)="onCartSelectionSubmit($event)"
    ></ct-create-dashboard-widget-form>
  </ng-container>
</wlm-popup-wrapper>
